import { Close, Save } from '@mui/icons-material'
import { LoadingButton } from '@mui/lab';
import { Dialog, DialogActions, DialogContent, DialogTitle, FormControl, Grid, InputAdornment, MenuItem, Select } from '@mui/material'
import ArgonBox from 'components/ArgonBox';
import ArgonButton from 'components/ArgonButton'
import ArgonInput from 'components/ArgonInput';
import ArgonTypography from 'components/ArgonTypography'
import { postSubmit } from 'global/postFunc';
import { useEffect, useState } from 'react';
import PropTypes from 'prop-types'

const EditProgram = ({ 
    open, 
    handleCloseDialog, 
    editData, 
    decryptedUser, 
    updating, 
    setUpdating, 
    addReq 
}) => {
    const [anggaran, setAnggaran] = useState('')
    const [saving, setSaving] = useState(false)

    const submit = (e) => {
        addReq()
        e.preventDefault();
        setSaving(true)
        postSubmit(
            '/admin-opd/tr-perencanaan/update',
            {
                _method: 'PUT',
                id: editData.id,
                anggaran: anggaran.replace(/,(?=\d{3})/g, '')
            },
            decryptedUser,
            (res) => {
                setSaving(false)
                handleCloseDialog()
                setAnggaran('')
                setUpdating(!updating)
            },
            (res) => {
                setSaving(false)
                handleCloseDialog()
            }
        )
    }

    useEffect(() => {
        if (open) {
            console.log(editData);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [open])

    const addCommas = num => num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    const removeNonNumeric = num => num.toString().replace(/[^0-9]/g, "");
    const handleAnggaranChange = (event) => {
        setAnggaran(addCommas(removeNonNumeric(event.target.value)))
    }

    return (
        <Dialog
            open={open}
            maxWidth="md"
            fullWidth
            scroll='paper'
            p={3}
            component='form'
            onSubmit={submit}
        >
            <DialogTitle>
                <ArgonTypography variant='body2' fontWeight="bold">Edit {editData.status}</ArgonTypography>
            </DialogTitle>
            <DialogContent p={3}>
                <ArgonBox mb={1}>
                    <ArgonBox mb={1} ml={0.5}>
                        <ArgonTypography component="label" variant="caption" fontWeight="bold">
                            {editData.status || ''}
                        </ArgonTypography>
                    </ArgonBox>
                    <FormControl fullWidth>
                        <Select
                            labelId="demo-simple-select-label"
                            id="demo-simple-select"
                            label="Age"
                            disabled
                            value={editData.id}
                        >
                            <MenuItem selected value={editData.id}>{editData.uraian}</MenuItem>
                        </Select>
                    </FormControl>
                </ArgonBox>
                <ArgonBox mb={1}>
                    <ArgonBox mb={1} ml={0.5}>
                        <ArgonTypography component="label" variant="caption" fontWeight="bold">
                            Anggaran
                        </ArgonTypography>
                    </ArgonBox>
                    <ArgonInput
                        type="text"
                        required
                        size="medium"
                        value={anggaran === '' ? editData.anggaran : anggaran}
                        onChange={handleAnggaranChange}
                        autoComplete='off'
                        startAdornment={
                            <InputAdornment position="start">
                                <ArgonTypography component="label" variant="caption" >
                                    Rp
                                </ArgonTypography>
                            </InputAdornment>
                        }
                    />
                </ArgonBox>
            </DialogContent>
            <DialogActions>
                <Grid container spacing={2} justifyContent='flex-end' px={2} mb={2}>
                    <Grid item>
                        <ArgonButton color='info' variant='outlined' size="small" startIcon={<Close />} onClick={handleCloseDialog}>Batal</ArgonButton>
                    </Grid>
                    <Grid item>
                        <LoadingButton color='info' variant='contained' size="small" startIcon={<Save />} type='submit' loading={saving}>Simpan</LoadingButton>
                    </Grid>
                </Grid>
            </DialogActions>
        </Dialog>
    )
}

EditProgram.prototype = {
    open: PropTypes.bool.isRequired, 
    handleCloseDialog: PropTypes.func.isRequired, 
    editData: PropTypes.object.isRequired, 
    decryptedUser: PropTypes.string.isRequired,
    updating: PropTypes.bool.isRequired, 
    setUpdating: PropTypes.func.isRequired, 
    addReq: PropTypes.func.isRequired, 
}

export default EditProgram